import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2, Lock } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="offer-section" className="py-24 bg-slate-900 relative overflow-hidden" data-id="element-139">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-600/20 rounded-full blur-[120px] pointer-events-none" data-id="element-140" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-141">
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-142">
          <div className="text-center mb-10" data-id="element-143">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-144">
              Recupera tu movilidad por menos de lo que cuesta un par de
              calcetines de compresión.
            </h2>
            <p className="text-lg text-slate-600" data-id="element-145">
              Acceso inmediato y de por vida a todo el material.
            </p>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-center justify-center mb-10" data-id="element-146">
            <div className="flex-1 space-y-4 w-full" data-id="element-147">
              {['Manual Digital: Adiós a la Fascitis Plantar', 'El Protocolo de 2 Minutos', 'Técnica Rolling-Freeze', 'Guía de Calzado para Trabajadoras', 'Plan de Acción de 7 Días'].map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-148">
                  <CheckCircle2 className="w-6 h-6 text-brand-500 flex-shrink-0" data-id="element-149" />
                  <span className="text-slate-700 font-medium" data-id="element-150">{item}</span>
                </div>)}
            </div>

            <div className="bg-slate-50 p-8 rounded-2xl border-2 border-brand-100 text-center w-full md:w-auto shrink-0" data-id="element-151">
              <p className="text-slate-500 line-through text-lg mb-1" data-id="element-152">
                Valor Normal: $47
              </p>
              <div className="flex items-start justify-center gap-1 text-slate-900 mb-2" data-id="element-153">
                <span className="text-2xl font-bold mt-2" data-id="element-154">$</span>
                <span className="text-7xl font-display font-black tracking-tight" data-id="element-155">
                  7
                </span>
                <span className="text-xl font-bold mt-2" data-id="element-156">USD</span>
              </div>
              <p className="text-brand-600 font-bold text-sm uppercase tracking-wider" data-id="element-157">
                Pago Único
              </p>
            </div>
          </div>

          <div className="text-center space-y-6" data-id="element-158">
            <CTAButton className="w-full md:w-auto md:px-12 py-5 text-xl" data-id="element-159" />

            <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-slate-500" data-id="element-160">
              <div className="flex items-center gap-2" data-id="element-161">
                <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-162" />
                <span data-id="element-163">Garantía de Satisfacción</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-164">
                <Lock className="w-5 h-5 text-slate-400" data-id="element-165" />
                <span data-id="element-166">Pago 100% Seguro</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}